import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles, {
  SKELETON_BAR_COUNT
} from './styles/SupportTicketsTable.styles'

/**
 * Loading placeholder built on the ROW's own grid module, per §7 — a skeleton
 * on a different grid causes the layout to jump when the data lands.
 */
const SupportTicketRowSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.tableRow}>
      {/* Derived from COLUMNS, never hand-counted. This number was wrong
          twice — when the checkbox track landed and again when the priority
          track did — and both times the bars silently sat one column from
          where their real content lands, so the layout jumped when the data
          arrived. That is precisely what this file exists to prevent. */}
      {Array(SKELETON_BAR_COUNT)
        .fill('')
        .map((_, index) => (
          <div key={`support-ticket-skeleton-cell-${index.toString()}`}>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        ))}
      <div />
    </div>
  )
}

export default SupportTicketRowSkeleton
